import React from 'react';
import style from './style.module.less';
import classNames from 'classnames';

const FRAME_COUNT = 4;

function Frame({ children, className, frameID, isLarge }) {
    const frameClass = frameID ? style[`frame_${frameID % FRAME_COUNT}`] : style.frame_0;
    const cN = classNames(style.frame, frameClass, className, { [style.frame_large]: isLarge });
    return (
        <div className={cN}>
            {children}
        </div>
    );
}

export default Frame;



// WEBPACK FOOTER //
// ../components/Frame/index.js